import React, {useEffect, useState, useRef} from 'react';
import * as prosConnect from './ProsConnect';
import {
    ATTR_AWS_PROJECT_ID,
    ATTR_CUSTOMER_GROUP,
    ATTR_MAIN_PROJ_ID,
    ATTR_MAIN_PROJECT_NAME,
    ATTR_PROJECT_STATE,
    ATTR_OBJ_TYPE,
    currentTimeMs,
    OBJ_STATE_ACT,
    OBJ_STATE_CREATE,
    ROLE_ADMIN,
    ROLE_INSPECT,
    ROLE_REPAIR,
    ROLE_READER,
    prosLog,
    ATTR_TEXT,
    ATTR_EXPIRATION,
    OBJ_STATE_PAS,
    awaitMakeProjectLink,
    prosLogErr,
    OBS_OBJ_LIST,
    OBJ_TYPE_ITM,
    OBS_PICTS,
    OBS_VIDEOS,
    OBJ_TYPE_SOUND,
    OBJ_TYPE_TXT_SOUND,
    OBJ_TYPE_ITM_PICT,
    ATTR_PDF_NAME,
    getItemThumpPath,
    isValueEmpty,
    toggleFollowObs,
    OBJ_TYPE_ITM_OBS,
    ATTR_OBJ_ID,
    ATTR_FILE_NAME,
    hasPermissionAndCapacityToAddContent,
    isPictureItem,
    getActiveProject,
    OBJ_TYPE_ITM_PICT_LOC,
    isVideoItem,
    featureEnabled,
    FEAT_CHANGE_ITEM_TYPE,
    VIEW_MODE_LIST,
    OBJ_TYPE_ITM_TITLE,
    ATTR_OBS_ID,
    isValidAttr,
    isTitle,
    OBJ_TYPE_ITM_VIDEO,
    OBJ_TYPE_LST,
    getObjListIdFromItemId,
    isSettingsView, OBJ_STATE_DEL, OBJ_STATE_TO_DEL, replaceAll,
    ATTR_OBJ_STATE
} from "./ProsConnect";
import {getRoleForTableUi} from "../containers/PermissionsTable"
import ProsRbTag from "./ProsRbTag";
import ProsChTag from "./ProsChTag";
import ProsTxtTag from "./ProsTxtTag"
import {ATTR_UPDATED_BY, ATTR_CREATED_BY} from "./ProsConnect";
import {ATTR_UPDATED_MS_I, ATTR_CREATED_MS_I} from "./ProsConnect";
import {STR_NO, STR_YES, STR_NO_VALUE} from "./ProsConnect";
import {gloGetReportView} from "../containers/Home";
import {useOutOfBounds, useOutsideCallback} from "../components/Common";
import {useModal} from "../components/Modal";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import {openCreateEditObsModal} from "../containers/modals/CreateEditObsModal";
import prosAppNotif, {
    prosAppNotifConfirm,
    prosAppNotifDismiss,
    prosAppNotifWait,
    prosAppNotifWarn
} from "./ProsAppNotif";
import LoadingAnimation from "../components/LoadingAnimation";
import {getHelpContentByField, setHelpContext} from "./HelpManager";
import {getLinkAddr, ProsLinkEditPopup} from "./ProsLink";
import TextInput from "../components/TextInput";
import ReactPlayer from "react-player";
import {getDependsOnThis, getThisDependsOn} from "./ProsObsDependencyListing";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import RadioButton from "../components/RadioButton";
import ImageWithMarker from "../components/ImageWithMarker";
import UiImage, {PictureImport, RotatePicture} from "../components/UiImage";
import {getCopyMoveManager} from "./CopyMoveManager";
import DropdownMenu from "../components/DropdownMenu";
import {renderUndoDeletedControl} from "./ProsObsHistoryListing";
import {renderWithRestoreControls} from "../containers/ProjectDeletedDataRestore";
import {USE_DEVELOPMENT_FEATURES} from "../config";

export const MS_IN_DAY = 24 * 60 * 60 * 1000;
const MS_IN_MINUTE = 60000;
const EIGHT_A_CLOCK_HOURS = 20;
const FOUR_A_CLOCK_HOURS = 16;

export const PROS_SELECTED_COLOR = "var(--color-main-60)";
export const PROS_ALERT_COLOR = "var(--color-no)";

export const PRODECT_DEFAULT_EMAIL_MSG = "Raportti linkki lähetetty sähköpostiin."

export const PROS_PASSWORD_RULES = "Pituus vähintään 8 merkkiä. Vähintään yksi iso ja pieni kirjain sekä numero.";

export const HELPER = {
    search: "Erota hakusanat pilkulla."//Todo Sampo check logic -> ", miinus-merkki sanan edessä jättää pois hakutuloksista."
}

export const MULTI_COLOR_SETS = {
    SET_1: [
        '#2FDEBE',
        '#60E6A9',
        '#91EF94',
        '#C1F77E',
        '#F2FF69'
    ],
    SET_2: [
        '#81A0FF',
        '#A1A1F5',
        '#C0A2EC',
        '#E0A3E2',
        '#FFA4D8'
    ],
    SET_3: [
        '#FF8D67',
        '#FFA269',
        '#FFB76B',
        '#FFCB6D',
        '#FFE06F'
    ],
    SET_4: [
        '#C49973',
        '#D3AF87',
        '#E2C69C',
        '#F0DCB0',
        '#FFF2C4'
    ]
}
export const MULTI_COLOR_SET_HILITE = [
    '#33FF00',
    '#FF33FF',
    '#00AEFF',
    '#fdf402',
    '#00f7ff'
]
export const MULTI_COLOR_SET_GRAY = [
    '#1D2938',
    '#4B5864',
    '#79878F',
    '#A7B6BB',
    '#D5E5E6'
]

export const MULTI_COLOR_OBS_STATE = [
    '#FDDC7F',
    '#BCEDDA',
    '#9BD4F4',
    '#F7A1B7',
    '#C6E8FD',
    '#D5DBE1',
]

export const STATE_ICON_CLASSES = [
    'ui-icon-semantic-disc ui-icon_color-maybe',    // 0
    'ui-icon-semantic-disc ui-icon_color-ok',       // 1
    'ui-icon-outline-check ui-icon_color-main',     // 2
    'ui-icon-semantic-disc ui-icon_color-no',       // 3
    'ui-icon-outline-info',                         // 4
];
const STATE_ICON_CLASS_OTHER = 'ui-icon-semantic-disc ui-icon_color-other';

export function getDefaultColor(rgInd, rbInd) {
    const colorList = Object.keys(MULTI_COLOR_SETS)
    const numOfSets = colorList.length
    const colorSetKey = colorList[rgInd % numOfSets]
    const colorOptions = rgInd === 0 ? MULTI_COLOR_OBS_STATE : MULTI_COLOR_SETS[colorSetKey]
    const numOfColorsInSet = colorOptions.length
    return colorOptions[rbInd % numOfColorsInSet].substring(1)
}


export function isProsStringEmpty(txt) {
    return !txt || txt.length === 0 || txt === STR_NO_VALUE;
}

export function strYesNoValue(boolValue) {
    return boolValue ? STR_YES : STR_NO;
}

// export function isProsStringYes(attr) {
//     return attr === STR_YES
// }

function validateEmail(email) {
    if (!email) {
        return "-"
    }
    if (email !== 'lambda-project-report' &&
        email !== 'server') {
        return email;
    }
    return undefined;
}

export function makeNameFromEmail(email) {
    let name = email.split('.')[0]
    if (name.indexOf('@') > 0) {
        name = email.split('@')[0]
        return name.charAt(0).toUpperCase() + name.slice(1)
    }
    let names = email.split('@')[0].split('.')
    let capitalNames = names.map(name => name.charAt(0).toUpperCase() + name.slice(1))
    return capitalNames.join(' ')
}

function cleanEmail(email) {
    return email
        .replace(/[\n #!"?]/g, '')
        .toLowerCase()
        .trim()
}

function cleanName(email) {
    return email
        .replace(/[\n#?]/g, '')
        .trim()
}

export function cleanFilename(email) {
    return replaceAll(email, ' ', '_')
        .toLowerCase()
    .trim()
}

//stored for later 21.02.2024
// export function getCSSvar(varName){
//     let colorValue = getComputedStyle(document.documentElement)
//         .getPropertyValue(varName)
//     return colorValue
// }

function parseNameAndEmailFromList(emailAndNames) {
    return emailAndNames.map (emailName => {
        if (emailName.indexOf(',') > 0) {
            return {
                name: cleanName(emailName.split(',')[0]),
                email: cleanEmail(emailName.split(',')[1])
            }
        }
        return {
            name: makeNameFromEmail(cleanEmail(emailName)),
            email: cleanEmail(emailName)
        }
    })
}

// Returns list of name and emails [{name: x, email, y}, ..]
export function parseNamesAndEmails(inputStr) {
    let hasSplit1 = inputStr.indexOf(',') > 0
    let hasSplit2 = inputStr.indexOf(';') > 0
    if (!hasSplit1 && !hasSplit2) {
        // one email
        return parseNameAndEmailFromList([inputStr])
    }
    if (hasSplit1 && hasSplit2) {
        // emails and names
        return parseNameAndEmailFromList(inputStr.split(';'))
    }
    // Split either by , or ;
    let splitChar = hasSplit1 ? ',' : ';'
    return parseNameAndEmailFromList(inputStr.split(splitChar))
}


export function getUpdatedBy(listObj) {
    let obj = prosConnect.getOriginal(listObj);
    let email = validateEmail(obj[ATTR_UPDATED_BY]);
    if (!email) {
        return obj[ATTR_CREATED_BY];
    }
    return email;
}

export function getCreatedBy(listObj) {
    let obj = prosConnect.getOriginal(listObj)
    return obj[ATTR_CREATED_BY]
}

// Get local time
export function formatDate(date, showHourMin=false, twoDigitDate =false, showSeconds=false) {
    if (!date) {
        return null;
    }
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        minutes = d.getMinutes();
    if (twoDigitDate) {
        month = month.length > 1 ? month : '0' + month
        day = day.length > 1 ? day : '0' + day
    }
    let dayStr = [day, month, year].join('.');
    if (!showHourMin) {
        return dayStr;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    const value = dayStr.concat(' ').concat([hour, minutes].join(':'));
    if(showSeconds){
        let secs = d.getSeconds();
        if (secs < 10) {
            secs = "0" + secs;
        }
        return value + "." + secs
    }
    return value;
}

export function getUpdatedTimeStr(listObj, showHourMin=false) {
    let obj = prosConnect.getOriginal(listObj);
    return formatDate(obj[ATTR_UPDATED_MS_I], showHourMin);
}

export function getCreatedTimeStr(listObj, showHourMin=false) {
    let obj = prosConnect.getOriginal(listObj)
    return formatDate(obj[ATTR_CREATED_MS_I], showHourMin)
}

export function getUpdatedTimeWithSecondsStr(listObj) {
    let obj = prosConnect.getOriginal(listObj);
    return formatDate(obj[ATTR_UPDATED_MS_I], true, false, true);
}

export function getEndOfWorkingDayTime(forTime, showHourMinFeature = false) {
    let date = new Date(forTime);
    date.setHours(showHourMinFeature ? FOUR_A_CLOCK_HOURS : EIGHT_A_CLOCK_HOURS);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

export function adjustDateToClock(forTime, begOfDay) {
    let date = new Date(forTime);
    date.setHours(begOfDay ? 0 : 23);
    date.setMinutes(begOfDay ? 0 : 59);
    date.setSeconds(begOfDay ? 0 : 59);
    date.setMilliseconds(0);
    return date.getTime();
}

const WEEK_DAY_MONDAY = 1;
export function getThisWeekMonday(forDate, hours) {
    let monday = new Date(forDate)
    let weekDay = forDate.getDay()
    if (weekDay) {
        // Monday .. Saturday
        monday.setDate(monday.getDate() - weekDay + WEEK_DAY_MONDAY);
    } else {
        // Sunday
        monday.setDate(monday.getDate() - 6);
    }
    monday.setHours(hours, 0, 0)
    return monday;
}

export function getEndOfWorkingDayTimeMs(forTime, showHourMinFeature = false) {
    let date = getEndOfWorkingDayTime(forTime, showHourMinFeature)
    return date.getTime()
}

export function formatUtcDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    return [day, month, year].join('.');
}

export function getLateText(item) {
    if (!prosConnect.isLate(item)) {
        return "";
    }
    let daysLate = (currentTimeMs() - prosConnect.getExpiration(item)) / MS_IN_DAY;
    if (daysLate <= 31) {
        return 'pv '+ Math.floor(daysLate)
    }
    return 'vko '+ Math.floor(daysLate/7);
}

export function getRemainingTimeToText(ms) {
    if (ms < 0 || ms === undefined) {
        // OBS done has -1, state - not ongoing or
        // expiration time has not been set
        return ""
    }
    let daysToDate = (ms - currentTimeMs()) / MS_IN_DAY;
    if (daysToDate >= 0) {
        if (daysToDate <= 31) {
            return Math.floor(daysToDate)+' pv'
        }
        return Math.floor(daysToDate/7)+' vko';
    } else {
        if (daysToDate <= -31) {
            return Math.floor(daysToDate/7)+' vko';
        }
        return Math.floor(daysToDate)+' pv'
    }
}

// returns a week number 1..53 for a Date in <forTime>
/**
 * Returns the week number for this date according to ISO-8601.
 *
 * Ref ISO-8601 chapter 2.2.10 calendar week number
 *  ordinal number which identifies a calendar week within its calendar year according
 *  to the rule that the first calendar week of a year is that one which includes the
 *  first Thursday of that year and that the last calendar week of a calendar year
 *  is the week immediately preceding the first calendar week of the next calendar year
 *
 * @return integer ISO-1806 week number 1..53
 */
export function getNumberOfWeek (forDay) {
    // getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.epoch-calendar.com
    // fixed by Tero as this returns zero before 1st week when should return last
    // week # of the previous year and using DOWOFFSET - week starts on Monday
    const DOWOFFSET = 1;
    let newYear = new Date(forDay.getFullYear(),0,1);
    let day = newYear.getDay() - DOWOFFSET; //the day of week the year begins on
    day = (day >= 0 ? day : day + 7);
    let daynum = Math.floor((forDay.getTime() - newYear.getTime() -
        (forDay.getTimezoneOffset()-newYear.getTimezoneOffset())*MS_IN_MINUTE)/MS_IN_DAY) + 1;
    let weeknum;
    //if the year starts before the middle of a week
    if(day < 4) {
        weeknum = Math.floor((daynum+day-1)/7) + 1;
        if(weeknum > 52) {
            let nYear = new Date(forDay.getFullYear() + 1,0,1);
            let nday = nYear.getDay() - DOWOFFSET;
            nday = nday >= 0 ? nday : nday + 7;
            // if the next year starts before the middle of
            // the week, it is week #1 of that year
            weeknum = nday < 4 ? 1 : 53;
        }
    }
    else {
        weeknum = Math.floor((daynum+day-1)/7);
        if (weeknum === 0) {
            // fix Tero scan backwards to get last week number of previous year
            let checkDate = new Date(forDay);
            for (let decDays = 1; decDays < 7; decDays++) {
                checkDate.setDate(checkDate.getDate() - 1);
                weeknum = getNumberOfWeek(checkDate);
                if (weeknum !== 0) {
                    return weeknum;
                }
            }
        }
    }
    return weeknum;
}

export function openInNewTab(url) {
    let w = window.open(url, 'Report');
    if (w) {
        prosLog('url opened with valid window');
    } else {
        prosLog('url opened with undefined window');
        alert("Selain esti sivun suoran avaamisen. \nSalli viimeisin pop-up selaimen otsikkopalkista tai käytä sähköpostia raportin linkin lähettämiseen")
    }
}

export function openUrl(url) {
    if (url && url.length > 10) {
        openInNewTab(url);
    } else {
        alert("web linkki virheellinen")
    }
}

// https://stackoverflow.com/questions/37353908/open-a-new-tab-in-safari-programmatically-using-js

export function stateUrgent(listObj, size = undefined) {
    //This only for viewer, can be removed when viewer fetches project data
    if(!prosConnect.getActiveProject()){
        return null
    }

    let obs = prosConnect.getOriginal(listObj)
    if (!prosConnect.isInStateOngoing(obs)) {
        return null
    }
    let tag = prosConnect.getActiveProject().getUrgentChTag()
    if (!tag || !obs.hasOwnProperty(tag)) return null
    if (obs[tag] === prosConnect.STR_YES) {
        return <i className={"ui-icon" + (size ? " ui-icon-" + size : "") + " ui-icon-semantic-urgent ui-icon_color-no"} title={"Kiireellinen"} />
    }
    return null
}

/**
 * An advanced text filtering function
 * @param filter        text filter
 * @param val           text to check if passes a filter
 * @returns boolean     if text to check match with filter
 *    filtering is NOT case sensitive
 *    comma separated filter is treated as an inclusive logical OR
 *    minus ('-')on front for exclusive comparison ( comma separated 'all except' )
 *    -  to get empty fields
 *    -- to get non-empty fields
 *    logical AND by & between sub filters to combine multiple filters which in turn can contain comma or negation
 *    Space character between filters is ignored
 *
 *    Examples:
 *      -                     -> empty field
 *      --                    -> non empty field
 *      projekti              -> contains "projekti": Projekti, asiaksprojekti etc
 *      asiakas, projekti     -> contains either "asiakas" or "projekti"
 *      -projekti             -> any other text except "projekti"
 *      asiakas & projekti    -> both "asiakas" or "projekti"
 *      asiakas & -projekti   -> has "asiakas" but not "projekti"
 */
export function prosMultiFilterText(filter, val) {
    if (filter === '' || typeof val !== 'string') {
        return true;
    }
    if (filter === '-') {
        // match fields which are empty
        return (!val || val === '')
    } else if (filter === '--') {
        // match fields which are non empty
        return val.length > 0
    }
    // '-' in front means exclusion
    let exclusive = filter.indexOf('-') === 0;
    if (exclusive) {
        filter = filter.substr(1)
    }
    if (filter.indexOf("&") > 0) {
        // Logical AND - recursively check conditions of sub filters separate by &
        let subFilters = filter.split("&")
        for (let subFilter of subFilters) {
            if (!prosMultiFilterText(subFilter, val)) {
                return false
            }
        }
        return true
    }
    let filters = filter.toLowerCase().split(',');
    for (let filter of filters) {
        let filterStr = filter.trim();
        if (filterStr === '') {
            continue;
        }
        if (val.toLowerCase().includes(filterStr)) {
            return !exclusive
        }
    }
    return exclusive;
}

export function renderNoCapacity(what) {
    return <p>{"Projektin kapasiteetti käytetty - ei voi lisätä " + what}</p>
}

export function getIconClass(ind) {
    if (ind >= STATE_ICON_CLASSES.length) {
        return STATE_ICON_CLASS_OTHER
    }
    return STATE_ICON_CLASSES[ind]
}

export function stateLate(obs, size = undefined) {
    if (prosConnect.isLate(obs)) {
        return <i className={"ui-icon" + (size ? " ui-icon-" + size : "") + " ui-icon-semantic-alarm ui-icon_color-no"} title={"Myöhässä"} />
    }
    return null
}

function getObsStateHtml(tagStr, size) {
    let project = prosConnect.getActiveProject()
    if (!project || !project.stateTag) {
        return null
    }
    let tagVal = parseInt(tagStr);
    let iconClass = getIconClass(tagVal);
    if (!iconClass) {
        return null
    }
    let stateText = project.getStateText(tagVal)
    return <i className={"ui-icon" + (size ? " ui-icon-" + size : "") + " " + iconClass} title={stateText}/>
}

export function stateIcon(listObj, size) {
    //This only for viewer, can be removed when viewer fetches project data
    if(!getActiveProject()){
        return null
    }
    let obs = prosConnect.getOriginal(listObj);
    let tag = prosConnect.getActiveProject().getStateRbTag();
    if (!tag) return null;
    if (!obs.hasOwnProperty(tag)) return null;
    return getObsStateHtml(obs[tag], size);
}

export function stateIcons(obs, size) {
    return <span className={"icon-set valign-top"}>
        {stateUrgent(obs, size)}
        {stateLate(obs, size)}
        {stateIcon(obs, size)}
    </span>
}

export function renderObsAttachments(obs, showUser = true) {
    if(!obs || !obs.hasOwnProperty(OBS_OBJ_LIST)) return null
    function obsIconCount(count, cssIcon, hoverTitle, icon = null) {
        if(!count) return null
        return <span
                title={(typeof count === 'number' ? count + " " : "") + hoverTitle}
                className={"icon-text-set-xs text-sm"}
            >
            {icon || <i className={"ui-icon ui-icon-sm " + cssIcon}/>}
            <span>{count}</span>
        </span>
    }
    const pictureCount = obs.hasOwnProperty(OBS_PICTS) ? obs[OBS_PICTS].length : 0
    const videoCount = obs.hasOwnProperty(OBS_VIDEOS) ? obs[OBS_VIDEOS].length : 0
    let comments = []
    let audioCount = 0
    let pdfCount = 0
    obs[OBS_OBJ_LIST].forEach(itm=>{
        if(itm.obj_type === OBJ_TYPE_SOUND) audioCount++
        if(itm.obj_type === OBJ_TYPE_ITM_PICT && itm.hasOwnProperty(ATTR_PDF_NAME)) pdfCount++
        if(itm.obj_type === OBJ_TYPE_ITM || itm.obj_type === OBJ_TYPE_TXT_SOUND) comments.push(itm)
    })
    const commentCount = comments.map(itm => {
            let itemText = prosConnect.getItemText(itm)
            let link = getLinkAddr(itemText)
            return link ? link.linkText ? link.linkText: link.link : itemText
    }).length
    let dependCount = 0
    let missingCount = 0
    //This only for viewer, can be removed when viewer fetches project data
    const project = prosConnect.getActiveProject()
    if(project){
        dependCount = ObsDependCount(obs, project)
        missingCount = project.countMissingMandatoryAttribute(obs)
    }
    // / This only for viewer, can be removed when viewer fetches project dataEND
    return <div className={"element-set flex-wrap"}>
        <FollowButton obs={obs} hide={!showUser} />
        {!!missingCount && obsIconCount(missingCount, "ui-icon-asterisk ui-icon_color-2nd", "puuttuvaa valintaa")}
        {obsIconCount(videoCount, "ui-icon-video", "videota")}
        {obsIconCount(pictureCount - pdfCount, "ui-icon-image", "kuvaa")}
        {obsIconCount(pdfCount, "ui-icon-document-text", "PDF-tiedostoa")}
        {obsIconCount(audioCount, "ui-icon-audio-spectrum", "äänitettä")}
        {obsIconCount(commentCount, "ui-icon-comment-text", "kommenttia")}
        {!!dependCount && obsIconCount(dependCount, "ui-icon-link", "yhteyttä")}
        {showUser && obsIconCount(obs[ATTR_CREATED_BY], "",
            "Kirjauksen tekijä", renderAuthorTag(obs, "sm", "gray", "margin-right-xs"))}
    </div>
}

export function tagTexts(listObj) {
    let project = prosConnect.getActiveProject()
    let obs = prosConnect.getOriginal(listObj)
    const disabled = listObj.ui_isHistoryItem === true
    return <>
            {project.getChTags().map((tag, i) =>
                <ProsChTag
                    key={i}
                    project={project}
                    obs={obs}
                    tag={tag}
                    tagIndex={i}
                    disabled={disabled}
                />
            )}
            {project.getRbTags().map((tag, i) =>
                <ProsRbTag
                    key={i}
                    project={project}
                    obs={obs}
                    tagIndex={i}
                    tag={tag}
                    disabled={disabled}
                />
            )}
            {project.getTxtTags().map((tag, i) =>
                <ProsTxtTag
                    key={i}
                    project={project}
                    obs={obs}
                    tagIndex={i}
                    tag={tag}
                    disabled={disabled}
                />
            )}
        </>
}

export function ProsUpdateInfo(props) {
    if (!props.prosObj) {
        return null;
    }
    let createdBy = validateEmail(props.prosObj[ATTR_CREATED_BY]) === '-' ? null : null
    let updatedBy = validateEmail(props.prosObj[ATTR_UPDATED_BY]) === '-' ? null : null
    let createdTxt = formatDate(props.prosObj[ATTR_CREATED_MS_I], true)
    let updatedTxt = formatDate(props.prosObj[ATTR_UPDATED_MS_I], true)
    if(!createdBy && !updatedBy && !createdTxt && !updatedTxt) return null
    return <>
        <Spacer size={"lg"}/>
        <p className="text-sm">
            {updatedTxt ? <>Muokattu: {updatedTxt} {updatedBy}<br/></> : null}
            {createdTxt ? <>Luotu: {createdTxt} {createdBy}<br/></> : null}
            {props.showId ? <>{props.prosId}<br/></> : null}
            {props.extra}
        </p>
    </>
}

export function StyledProjectInfo(props) {
    if (!props.prosObj) {
        return null
    }
    let createdBy = validateEmail(props.prosObj[ATTR_CREATED_BY]);
    let updatedBy = validateEmail(props.prosObj[ATTR_UPDATED_BY]);
    let createdTxt = formatDate(props.prosObj[ATTR_CREATED_MS_I], true)
    let updatedTxt = formatDate(props.prosObj[ATTR_UPDATED_MS_I], true)

    switch(props.info) {
        case "created": return <><h6>Luotu</h6><p>{createdTxt}<br/>{createdBy}</p></>
        case "archived": return <><h6>Arkistoitu</h6><p>{updatedTxt}<br/>{updatedBy}</p></>
        case "id": return props.showId ? <><h6>Projekti ID</h6><p>{props.prosId}</p></> : null
        default: return null
    }
}

export function ObsStateHistoryItem(props) {
    // pros.hist is an object with fields:
    //      state   - '0', '1', ... value of the state
    //      email   - by whom
    //      timeMs  - when
    let stateLabels = prosConnect.getActiveProject().getRbTagLabels(0);
    let stateVal = parseInt(props.hist.state);
    let stateTxt;
    if (stateVal < stateLabels.length) {
        stateTxt = stateLabels[stateVal];
    }
    let timeStr = formatUtcDate(parseInt(props.hist.timeMs));
    return (
        <tr key={timeStr + stateTxt}>
            <td><div className={"icon-text-set"}>{getObsStateHtml(props.hist.state, 'sm')}<span>{stateTxt}</span></div></td>
            <td>{timeStr}</td>
            <td>{props.hist.email}</td>
        </tr>
    );
}

export function ObsDependCount(obs, project) {
    let everyObs = project.getObservations()
    let depends_on = getThisDependsOn(obs, everyObs, false).length
    let depends_on_this = getDependsOnThis(obs, everyObs, false).length
    return depends_on + depends_on_this
}

export function ObsDependencyItem(props) {
    const ddate = formatDate(+props.dependency[ATTR_EXPIRATION])
    return <div
            onClick={props.onSelectObs}
            className={"element-set dependency-item"
                + (props.dependency === props.active_obs ? " active" : "")
            }
        >
        <div className={"flex-grow"}>
            <TextContent
                text={(props.dependency.obs_id ? props.dependency.obs_id + " " : "") + props.dependency[ATTR_TEXT]}
                maxLength={100}
            />
            {ddate ?
                <span className={"text-sm icon-text-set-xs"}><i className={"ui-icon ui-icon-sm ui-icon-alarm"}/>{ddate}</span>
                : <span className={"text-xs color-no"}>Ei määräaikaa.</span>}
        </div>
        <BasicButton
            title="Poista yhteys"
            action={props.callback}
            icon={"times"}
            iconSize={"md"}
            btnType={canAddEditObs() ? "prompt" : "locked"}
        />
        {stateIcon(props.dependency, 'sm')}
    </div>
}

/**
 * Make a 2-dim array from main projects and sub-projects used by UI components listing projects
 * @param projectType - 'ACT', 'PAS' or 'all'
 * @param extraTitleSelection - to add an empty 'label selector'
 * @param includeNewMainProjects - to include main project that does not have subprojects
 * @param includeNewMainProjects - to include Example projects
 * @param forceFetch             - Force to fetch from server
 * @returns {Promise<*[]|[{projects: *[], customerGroup: undefined, ui_isOpen: boolean, name, origIndex: number, mainProjectId: undefined, referenceToCreateNew: undefined}]>}
 */
export async function makeUiMainProjectList(projectType, extraTitleSelection,
                                            includeNewMainProjects, includeExamples, forceFetch) {
    function doesProjectStateMatch(project) {
        if (!includeExamples && project[ATTR_CUSTOMER_GROUP] === 'EXAMPLES') {
            return false
        }
        if (!includeNewMainProjects && project[ATTR_PROJECT_STATE] === OBJ_STATE_CREATE) {
            return false
        }
        if (projectType === 'all') {
            return true
        }
        return project[ATTR_PROJECT_STATE] === projectType ||
            (project[ATTR_PROJECT_STATE] === OBJ_STATE_CREATE && projectType === OBJ_STATE_ACT)
    }
    let mainProjectsList = extraTitleSelection ?
        [{
            name: extraTitleSelection,
            customerGroup: undefined,
            mainProjectId: undefined,
            ui_isOpen: false,
            referenceToCreateNew: undefined,
            projects: [],
        }] : []

    // Fetch list of user projects from server ( or cached )
    let projects = await prosConnect.awaitGetProjects(forceFetch)
    if (!Array.isArray(projects)) {
        return []
    }
    // Use saved project order to make intial project list with id's only
    let projectOrder = await prosConnect.getUserSettingsProjectOrder()
    if (Array.isArray(projectOrder)) {
        projectOrder.forEach(mainProj => {
            let subProjects = mainProj.pids.map(pid => {
                return {
                    [ATTR_AWS_PROJECT_ID]: pid
                }
            })
            mainProjectsList.push({
                mainProjectId: mainProj.mpid,
                projects: subProjects
            })
        })
    }

    // make two level hierarchy list - main project / project
    let activeProject = prosConnect.getActiveProject()
    projects
        .filter(project => doesProjectStateMatch(project))
        .forEach(project => {
            let mainProjectName = project[ATTR_MAIN_PROJECT_NAME]
            let mainProjectId = project[ATTR_MAIN_PROJ_ID]
            let customerGroup = project[ATTR_CUSTOMER_GROUP] || '??'
            let mainProject = mainProjectsList.find(mainProject => mainProject.mainProjectId === mainProjectId)
            if (!mainProject) {
                mainProject = {
                    name: mainProjectName,
                    customerGroup: customerGroup,
                    mainProjectId: mainProjectId,
                    ui_isOpen: false,
                    referenceToCreateNew: undefined,
                    projects: [],
                }
                mainProjectsList.push(mainProject)
            } else if (!mainProject.name) {
                // Update main project info as for project order saved id's only
                mainProject.name = mainProjectName
                mainProject.customerGroup = customerGroup
                mainProject.ui_isOpen = false
                mainProject.referenceToCreateNew = undefined
            } else {
            }
            let subProject = mainProject.projects.find(proj => proj[ATTR_AWS_PROJECT_ID] === project[ATTR_AWS_PROJECT_ID])
            if (subProject) {
                // fill in details to sub project that was set from "order of projects"
                Object.assign(subProject, project)
            } else {
                // Subproject missing from order - append at the end of the sub project list
                mainProject.projects.push(project)
            }
            if (activeProject && activeProject.getPid() === project[ATTR_AWS_PROJECT_ID]) {
                // Set active subproject's main project as opened
                mainProject.ui_isOpen = true;
            }
            // Default reference project from which to copy settings to create a new sub project is either
            //  - active project when same as main project - or
            //  - main projects last sub-project for which have admin right
            if (activeProject && activeProject.getAttr(ATTR_MAIN_PROJ_ID) === mainProjectId &&
                prosConnect.hasPermissionTo("addProject")) {
                mainProject.referenceToCreateNew = activeProject.attrs;
            } else if (prosConnect.hasPermissionTo("addProject", project, project, false)) {
                mainProject.referenceToCreateNew = project;
            }
        })
    // Remove main and sub project that was saved to users project_order but is no longer active
    // Main project and sub project without name will be removed
    let orderedProjects = mainProjectsList.filter(mainProj => mainProj.name)
    orderedProjects.forEach((mainProj, i) => {
            mainProj.origIndex = i
            mainProj.projects = mainProj.projects.filter(proj => proj.text)
        })
    return orderedProjects
}

export function ProjectHeader(props) {
    if (props.mainProjectView) {
        return <header className="page-header element-set">
            <h1>{props.mainProjectName}</h1>
            {props.children}
        </header>
    }
    const subprj = prosConnect.getActiveProject()
    if (!subprj) {
        return null
    }
    const hasExtraInfo = subprj.attrs.is_template === prosConnect.STR_YES
        || subprj.attrs[ATTR_OBJ_STATE] === OBJ_STATE_PAS

    return <header className="page-header element-set">
        <h1>
            {hasExtraInfo ? <>{subprj.attrs[ATTR_MAIN_PROJECT_NAME]}&nbsp;/&nbsp;{prosConnect.getProjectInfo()}</>
                : <>{prosConnect.getProjectInfo()}<p className={"margin-0 text"}>{subprj.attrs[ATTR_MAIN_PROJECT_NAME]}</p></>}
            {hasExtraInfo ? <div className="element-set-sm">
                    {subprj.attrs.is_template === prosConnect.STR_YES &&
                        <span className="title-addon text-sm">MALLI</span>}
                    {subprj.attrs[ATTR_OBJ_STATE] === OBJ_STATE_PAS && <span className="color-2nd icon-text-set-xs">
                            <i className="ui-icon ui-icon-md ui-icon-outline-lock ui-icon_color-2nd" />Arkistoitu
                        </span>}
                </div> : null}
        </h1>
        {props.children}
    </header>
}

const MIN_EMAIL_LEN = 6;
const EMAIL_INVALID_CHARS = ['Ä','Ö','Å','ä','å','ö',';',':','%','/','&','=','"']
const EMAIL_INVALID_PREFIX = 's-postiosoite virheellinen: '
export function whyEmailStringNotValid(email) {
    if (email.length < MIN_EMAIL_LEN) {
        return EMAIL_INVALID_PREFIX + "liian lyhyt, minimi " + MIN_EMAIL_LEN + " merkkiä"
    }
    if (email.indexOf("@") < 0) {
        return EMAIL_INVALID_PREFIX + "puuttuu @-merkki"
    }
    if (email.split("@").length !== 2) {
        return EMAIL_INVALID_PREFIX + "enemmän kuin yksi @-merkki"
    }
    for (let invalidChar of EMAIL_INVALID_CHARS) {
        if (email.indexOf(invalidChar) >= 0) {
            return EMAIL_INVALID_PREFIX + "virheellinen merkki: " + invalidChar
        }
    }
    return ""
}

export function isValidEmail(email, isMandatory) {
    if ((!email || email === '') && !isMandatory) {
        return true
    }
    email = email.replaceAll(' ', '').trim()
    /* eslint-disable no-useless-escape */
    const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    return pattern.test(email)
}

export function isMultipleEmailsValid(emailsString){
    const emailArr = emailsString.split(',') || []
    let allValid = emailArr.filter(eml=> isValidEmail(eml, true))
    return allValid.length === emailsString.split(',').length
}

export function validateEmailsString(str, isMandatory){
    let emlList = str.split(',')
    let allValid = true
    emlList.forEach((item)=> {
        if(!isValidEmail(item, isMandatory)) allValid = false
    })
    return allValid
}

export function isValidPassWord(pwd){
    //Pituus 8+ merkkiä, vähintään yksi iso ja pieni kirjain ja numero.
        if(pwd.length < 8) return false
        if(!/[0-9]/.test(pwd)) return false
        if(!/[A-Z]/.test(pwd)) return false
        if(!/[a-z]/.test(pwd)) return false
    return true
}

export function isValidCode(num){
        if(num.length < 6) return false
        if(!/[0-9]/.test(num)) return false
    return true
}

export function renderPermissionElement(role, showText = false, group_name = null) {
    const ROLES = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER].map((role, i) =>  {
        return {role: role, label: getRoleForTableUi(role), boxCount: 4 - i}
    })
    let rolePresentation = ROLES.find(r => r.role === role)
    if(!rolePresentation) {
        return <div className={"permission-element permission-element-empty"}><i className={"ui-icon ui-icon-xs ui-icon-minus"}/></div>
    }
    // Permission level visualized by boxes
    let boxes = [];
    for(let i = 4; i > 0; i--){
        boxes.push(<span key={i} className={"tag" + (rolePresentation.boxCount >= i ? " active" : "")}> </span>)
    }
    const roleText = showText ? <p>{rolePresentation.label}</p> : null
    return <>
        {(group_name ? <div className={"permission-element permission-element-group"}>
            <span>
                <i className={"ui-icon ui-icon-md ui-icon-group ui-icon_color-2nd"}/>
            </span>
            {roleText}
        </div>
        : <div className={"permission-element"}>{boxes}{roleText}</div>)}
    </>
}

export const getItemTypeText = (obj) => {
    const type = prosConnect.renderType(obj)
    const typeMap = {
        'pict': 'kuva',
        'audio': 'ääni',
        'audio_txt': 'äänite + kommentti',
        'loc_pictures': 'sijantikuva',
        'obs': 'kirjaus',
        'text': 'kommentti',
        'video': 'video',
        'title': 'otsikko',
        'report': 'raportti',
    };
    if(type in typeMap){
        return typeMap[type];
    }
    return obj[ATTR_OBJ_TYPE];
}

export function canAddEditObs(){
    return prosConnect.getActiveProject() && prosConnect.getActiveProject().isProjectActive()
        && (prosConnect.hasPermissionTo('editObj') || prosConnect.hasPermissionTo('addContent'))
}

/**
 * @param action        function to be called when clicked
 * @param label         button text
 * @param icon          btn-icon-?
 * @returns {JSX.Element}
 * @constructor
 */
export function FloatButton(props) {
    //Left here if scrolling is needed later
    //const [showText, setShowText] = React.useState(true)
    //const [posY, setPosY] = React.useState(0)
    //Commented outer until major architecture change in future
    // React.useEffect(() => {
    //     function throttle (callbackFn, limit) {
    //         let wait = false
    //         return function () {
    //             if (!wait) {
    //                 callbackFn.call();
    //                 wait = true
    //                 setTimeout(function () {
    //                     wait = false
    //                 }, limit)
    //             }
    //         }
    //     }
    //
    //     function handleScroll(){
    //         let show = window.pageYOffset < window.innerHeight * 0.75//3/4 window height, hide button text
    //         if(show) return
    //         if(posY > window.pageYOffset) show = true
    //         setShowText(show)
    //         setPosY(window.pageYOffset)
    //     }
    //
    //     window.addEventListener('scroll', throttle(handleScroll, 200), {passive: true})
    //     //Clean Up
    //     return () => {
    //         window.removeEventListener('scroll', throttle)
    //     }
    // })
    if (!canAddEditObs()){
        return null
    }
    return <span className={"float-right-bottom"}>
        <div className={"float-button"}>
            <AddObsButton
                icon={props.icon || "plus"}
                disabled={props.disabled || false}
            />
        </div>
    </span>
}

/**
 * @param props     props
 * @returns {JSX.Element}
 * @constructor
 */
export function AddObsButton(props) {
    const modalContext = useModal()
    if (!canAddEditObs()){
        return null
    }
    return <BasicButton
        btnClass={props.btnClass || "primary"}
        label={"Lisää kirjaus"}
        icon={props.icon || "plus"}
        action={() => {
            openCreateEditObsModal(modalContext, undefined, props.report, {attrs: props.attrs || {}})
        }}
        disabled={props.disabled || false}
        shrink={"xl"}
        size={props.size}
        className={"btn-add-obs"}
        hilite={props.btnClass}
    />
}

export function EditObsButton(props) {
    const modalContext = useModal()
    if (!canAddEditObs()){
        return null
    }
    return <BasicButton
        btnClass={props.btnClass}
        label={props.label}
        icon={props.icon || "edit"}
        action={() => {
            openCreateEditObsModal(modalContext, props.obs, props.report, {})
        }}
        btnType={"prompt"}
        disabled={props.disabled || false}
        shrink={props.shrink}
        size={props.size}
    />
}

export function openPictureImportModal(obs, callback) {
    BasicModal('Lisää liite', <PictureImport
            obs={obs}
            callback={callback}
        />,
        {
            hideDismissButton: true
    })
    setHelpContext('importPicture')
}

/**
 * Make www link url and copy it to the clipboard
 * @param linkId        undefined to create a new link,
 *                      view mode (list, table) for project default link
 *                      or linkId to be updated
 * @param obsRef        Additional link reference to OBS
 * @returns {Promise<string>}  undefined - failed to make a link,
 *                              "ok" - link copied into clip board
 *                              else url / link text as copy to clipboard failed
 * URL is a web link to open prodect web ui application which fetches from server a link by id.
 * Link information contains a sub project and ite selected reports and view (list, table, matrix) specific settings.
 * Web client uses further OBS reference ( which is either identifier or obs DB object id) to set UI focus on that OBS.
 *
 * Link examples - in test server using local web console
 *      project link            http://localhost:3000/?link=010-001;RjJXdYBb4VEV
 *      OBS link with obs ID    http://localhost:3000/?link=010-001;RjJXdYBb4VEV;1.2
 *      OBS link with obj id:   http://localhost:3000/?link=010-001;RjJXdYBb4VEV;2551ab5b-a7cc-4836-aca1-7bf84c1325b1-W20030_W20030_1672474336414_6
 */
export const makeAndSaveProjectLink = async (linkId, obsRef)=> {
    let wwwLink = await awaitMakeProjectLink(false, linkId)
    if (wwwLink) {
        if (obsRef) {
            wwwLink += ";" +  obsRef
        }
        let linkToClipBoardSucceeded
        if (navigator.clipboard) {
            await navigator.clipboard.writeText(wwwLink)
            linkToClipBoardSucceeded = true
        } else {
            if(window.clipboardData) { // Internet Explorer
                window.clipboardData.setData("Text", wwwLink);
                await navigator.clipboard.writeText(wwwLink)
                linkToClipBoardSucceeded = true
            }
        }
        if (linkToClipBoardSucceeded) {
            prosAppNotif("Linkki kopioitu leikepöydälle")
            //todo Sampo to check style for link text put the following line as comment
            return "ok"
        } else {
            prosAppNotif("Selain ei anna kopioida linkkiä leikepöydälle")
        }
    } else {
        prosAppNotifWarn("Linkin teko epäonnistui")
    }
    return wwwLink
}

export function MakeWebLinkToClipBoard({buttonTitle, linkId, obsRef, onDone}){
    /**
     * props
     *     buttonTitle  Text shown in menu button
     *     linkId       ref makeAndSaveProjectLink()
     *     obsRef       Additional link reference to OBS
     *     onDone       called when operation completed
     */
    const [isBusy, setIsBusy] = React.useState()
    const [showCopyLink, setShowCopyLink] = React.useState()

    if (showCopyLink) {
        // failed to copy link to clip-board - show a text box to copy link from
        return <TextInput
            label={"Linkki kirjaukseen"}
            value={showCopyLink}
            info={"Kopioi linkki tästä - valitse ja paina (ctrl-a ja ctrl-c)"}
        />
    }

    async function createLinkToObs(){
        setIsBusy(true)
        // set linkId undefined to create a new link
        let wwwLink = await makeAndSaveProjectLink(linkId, obsRef)
        if (wwwLink === "ok") {
            if(typeof onDone === 'function') onDone()
        } else if (wwwLink) {
            setShowCopyLink(wwwLink)
        }
        setIsBusy(false)
    }

    return isBusy ? <LoadingAnimation />
        :
        <BasicButton
            label={buttonTitle}
            action={()=> createLinkToObs()}
            icon={"copy"}
            title={"Tee web-linkki"}
        />
}

function getLocalStorageBoolean(key, defVal) {
    let value = localStorage.getItem('sidebarStateOpen')
    return !isValueEmpty(value) ? JSON.parse(value) : defVal
}

export const sideBarState = {
    get: ()=>{
        let sidebarState = {
            open: getLocalStorageBoolean('sidebarStateOpen', true),
            locked: getLocalStorageBoolean('sidebarStateLocked', false)
        }
        return sidebarState
    },
    set: (open, locked)=>{
        localStorage.setItem('sidebarStateOpen', open)
        localStorage.setItem('sidebarStateLocked', locked)
    },
    reset: ()=>{
        localStorage.removeItem('sidebarStateOpen')
        localStorage.removeItem('sidebarStateLocked')
    }
}

//export var SMALL_DEVICE = isSmallDevice()//needs resize functionality LATER!
export function isSmallDevice(){
    return window.outerWidth < 992
}


/**
 * @param show        show/hide sidepanel
 * @returns {JSX.Element}
 * @constructor
 */
export function SidePanel(props) {
    const [show, setShow] = React.useState(props.show)
    //const sidePanelRef = useRef()
    React.useEffect(() => {
        setShow(props.show)
        //Will need to wait for all images to be loaded, and then scroll to bottom, LATER!
        // if (sidePanelRef.current) {
        //     if(props.show){
        //         //sidePanelRef.current.scrollTop = sidePanelRef.current.scrollHeight
        //         sidePanelRef.current.scrollTo({
        //             top: sidePanelRef.current.offsetHeight + sidePanelRef.current.scrollHeight,
        //             behavior: 'smooth',
        //         })
        //     }
        // }
    }, [props])
    if(!show){
        return null
    }
    return  <div
            id="sidePanel"
            className={"side-panel" + (show ? " show" : "")}
        >
        <div
            //ref={sidePanelRef}
            className="scrollpane-vertical"
        >
            {props.children}
        </div>
        <BasicButton
            icon={"times"}
            action={()=> {
                if(typeof props.closeCallback === 'function') props.closeCallback()
                setShow(false)
            }}
        />
    </div>
}

export function QuickHelpButton(props){
    const [showQuickHelp, setShowQuickHelp] = useState(false)
    const [quickHelpText, setQuickHelpText] = useState(null)
    const [quickHelpTitle, setQuickHelpTitle] = useState(null)
    const btnRef = useRef()

    function toggleQuickHelp(){
        if(!showQuickHelp) getQuickHelpText()
        setShowQuickHelp(!showQuickHelp)
    }
    
    async function getQuickHelpText() {
        if(props.openCallback){
            const helper = await props.openCallback()
            const txt = helper[OBS_OBJ_LIST].map((itm, i) => <p key={i}>{itm[ATTR_TEXT]}</p>)
            setQuickHelpTitle(helper[ATTR_TEXT] || null)
            setQuickHelpText(txt || null)
            return
        }
        let obs = await getHelpContentByField(props.field)
        let text = obs?.text && !props.helpText ? obs.text : props.helpText
        if (!text) {
            prosLogErr('QuickHelpButton text not found. Field:', props.field)
        }
        setQuickHelpText(text ? <p>{text}</p> : ' ')//<-- Has to be some value (empty space) or change to something smarter
    }

    function renderTitle(){
        if(!quickHelpTitle) return null
        return <h6>{quickHelpTitle}</h6>
    }

    function renderText(){
        if(!quickHelpText) return <LoadingAnimation color={"var(--color-light)"} />
        return quickHelpText
    }

    const QuickHelpMessage = function(props) {
        const [msgRef, outOfBounds] = useOutOfBounds(showQuickHelp)

        // React.useLayoutEffect(() => {
        //     console.log('1')
        //     return ()=> {
        //         console.log('2')
        //         return
        //     }
        // }, [])

        return <div
            ref={msgRef}
            className={"msg-quick-help " + outOfBounds + " msg text-sm "
                + (props.position ? "msg-quick-help-" + props.position : "")
            }
            onClick={()=> toggleQuickHelp()}
        >
            <BasicButton
                btnClass={"primary"}
                icon={"times"}
                size={"md"}
                action={()=> toggleQuickHelp()}
            />
            {renderTitle()}
            {renderText()}
            {props.children}
        </div>
    }

    useOutsideCallback(btnRef, () => setShowQuickHelp(false))
    return <span
            ref={btnRef}
            className={"quick-help"}
        >
        <BasicButton
            btnClass={"primary"}
            icon={props.type || "help"}
            size={"sm"}
            action={()=> toggleQuickHelp()}
            className={"btn-quick-help"}
            selected={showQuickHelp}
            loading={showQuickHelp && !quickHelpText}
        />
        {showQuickHelp && quickHelpText ? <QuickHelpMessage {...props} /> : null}
    </span>
}

export function showMandatoryAndMissingMessage(show){
    if(!show) return null
    return <div
            className={"msg msg-mia display-flex margin-bottom valign-center"}
        ><i className={"ui-icon ui-icon-sm ui-icon-asterisk ui-icon_color-2nd"}/>
        <p>pakollinen tieto puuttuu</p>
    </div>
}

export function VideoPlayer(props){
    const item = props.item
    const previewImg = getItemThumpPath(item)
    const videoUrl = prosConnect.getItemVideoPath(item)
    let noteMissingPreviewPicture = previewImg ? null : <p className={"text-xs"}>Ei esikatselukuvaa</p>
    function renderReactPlayer(){
        return <div className="media media-video">
            {previewImg ? <UiImage
                imageSrc={previewImg}
                className={"video-preview margin-auto"}
                alt={"Videon esikatselukuva"}
            /> : null}
            <ReactPlayer
                key={item.obj_id + '__rv_rp'}
                url={videoUrl}
                controls={true}
                light={previewImg || true}
                playing={!!previewImg}
                playbackRate={props.playbackRate || 1}
                width={"100%"}
                height={"100%"}
                className={"video-player"}
            />
            {noteMissingPreviewPicture}
        </div>
    }
    return renderReactPlayer()
}

export function AudioPlayer(props){
    const [isPlaying, setIsPlaying] = useState(false)
    function renderElement(){
        if(!isPlaying){
            return null
        }
        const item = props.item
        const audioPath = prosConnect.getItemAudioPath(item)
        return <audio key={item.obj_id + '__ra'} controls autoPlay={true}>
            <source src={audioPath} type="audio/wav"/>
            Selaimesi ei tue audiota
        </audio>
    }

    return <div className={"audio-player"}>
        {renderElement()}
        <BasicButton
            btnClass={"2nd"}
            icon={isPlaying ? "times" : "audio-spectrum"}
            label={isPlaying ? null : "Toista äänite"}
            action={()=> setIsPlaying(!isPlaying)}
        />
    </div>
}

export function contentByWhomClasses(item, isObsAuthor){
    if(!item) return ""
    let cssList = []
    if (isCreator(item)) cssList.push("content-by-user")
    if (isObsAuthor) cssList.push("content-by-author")
    return " " + cssList.join(" ")
}

function isCreator(item){
    if(!item?.hasOwnProperty(ATTR_CREATED_BY)){
        return false
    }
    return item[ATTR_CREATED_BY] === prosConnect.getUserEmail(true)
}

function renderAuthorTag(item, size = null, iconColor = "gray",  cssClass = ""){
    return <UiIcon
        icon={"outline-shield"}
        size={size}
        color={iconColor}
        className={cssClass + (iconColor !== "gray" ? contentByWhomClasses(item, true) : "")}
    />
}

export function UiAvatar({item, ...props}){
    const [showMore, setShowMore] = useState(false)
    let createdBy = null
    if(item) createdBy = getCreatedBy(item)

    function renderText() {
        let updatedBy = getUpdatedBy(item)
        let updatedStr = getUpdatedTimeStr(item, true)
        function renderEditButton(){
            let editedStr = null
            let createdStr = getCreatedTimeStr(item, true)
            if (createdStr !== updatedStr) {
                editedStr = <>
                    {/*{updatedBy !== createdBy ? <>{updatedBy} {updatedStr}</> : null}*/}
                    <span className={"display-flex"}>{createdStr} {createdBy}</span>
                </>
            }
            if(!editedStr) return null
            return <>
                <span
                        onClick={()=> setShowMore(!showMore)}
                        className={"capsule"
                            + (showMore ? " active" : "")
                        }
                    >Muokattu</span>
                    {showMore ? <>
                            <span>{editedStr}</span>
                        </>: null}
            </>
        }

        return <div>
            {updatedBy}
            <p className={"margin-0"}>{updatedStr}{renderEditButton()}</p>
        </div>
    }

    const creator = props.isObsAuthor
        ? renderAuthorTag(item, "sm", "light") : null
    let icon= item && isCreator(item) ? "user" : null
    if(props.icon) icon = props.icon
    let text = !icon ? createdBy : null
    if(props.text) text = props.text
    return <div className={"element-set-sm flex-grow ui-avatar text-sm"
            + contentByWhomClasses(item, props.isObsAuthor)
        }>
        <UiIcon
            icon={icon}
            color={"light"}
            text={props.iconText || text}
            className={contentByWhomClasses(item, props.isObsAuthor)
                + (props.className ? " " + props.className : "")
            }
        />
        {creator}
        {item ? renderText() : text}
    </div>
}

export function UiIcon({icon, text, color, ...props}) {
    return <i className={"ui-icon "
        + (icon ? "ui-icon-" + icon : "ui-icon_text")
        + (color ? " ui-icon_color-" + color : "")
        + (props.size ? " ui-icon-" + props.size : "")
        + (props.className ? " " + props.className : "")
        + (props.rounded ? " rounded" : "")
    }>{icon ? null : text ? text.substring(0, 1) : null}</i>
}

export function validateTextInput(inputText) {
    let txt = inputText.replaceAll(STR_NO_VALUE, '')
    if (txt === '') {
        prosAppNotif("Teksti puuttuu!")
        return undefined
    }
    return txt
}

export function checkToWarnCloseToCapacityLimit() {
    let stats = prosConnect.getActiveProject().getItemCountStats()
    if(stats) {
        let remainingCapacity = stats.itemsCountLimit - stats.itemsTotal
        if (remainingCapacity < 10) {
            prosAppNotifConfirm("HUOM projektissa tilaa " + remainingCapacity + " tiedolle")
        }
    }
}


export function getTextForObjectType(menuTxt, item = null, str = null) {
    const key = str ? prosConnect.renderType(null, str) : prosConnect.renderType(item)
    switch (key) {
        case 'loc_pictures':
        case 'pict':
            return menuTxt + " kuva"
        case 'obs':
            return menuTxt + " kirjaus"
        case 'report':
            return menuTxt + " raportti"
        case 'title':
            return menuTxt + " otsikko"
        case 'text':
            return menuTxt + " kommentti"
        default:
            return menuTxt
    }
}

export function getObjectStateText(state, lowercase){
    const states = {
        [OBJ_STATE_ACT]: 'Aktiiivinen',
        [OBJ_STATE_PAS]: 'Arkistoitu',
        [OBJ_STATE_DEL]: "Poistettu",
        [OBJ_STATE_TO_DEL]: "Poistettu",
    }
    if(lowercase) return states[state].toLowerCase()
    return states[state]
}

export function isEnumSelectionType(textFieldType) {
    return textFieldType.startsWith("email") || textFieldType.startsWith("enum")
}

export function isMultiEnumSelectionType(textFieldType) {
    return textFieldType.startsWith("emails") || textFieldType.startsWith("enums")
}

export const TEXT_FIELD_WHEN_MISSING = '-'

export function getTextFieldText(project, obs, tag) {
    let txt = prosConnect.getValidAttr(obs, tag, TEXT_FIELD_WHEN_MISSING)
    let textFieldType = project.getTextFieldType(tag)
    if (isMultiEnumSelectionType(textFieldType)) {
        let values = txt.split(';')
        return values.length < 2 ? txt : 'Useita (' + values.length + ')'
    }
    return txt
}

export function FollowButton({obs, ...props}){
    const [selected, setSelected] = useState(false)
    if(props.hide || !USE_DEVELOPMENT_FEATURES) return null
    return <BasicButton
        icon={"star"}
        label={"Seuraa"}
        iconColor={selected && "light"}
        action={()=> {
            toggleFollowObs(obs, !selected)
            setSelected(!selected)
        }}
        size={"sm"}
        selected={selected}
        className={"btn-type-follow"}
    />
}

export function UiItemFooter({item, isObsAuthor, customElement}) {
    return <footer className={"element-set ui-avatar-footer"
            + contentByWhomClasses(item, isObsAuthor)
        }>
        <UiAvatar
            item={item}
            isObsAuthor={isObsAuthor}
        />
        {customElement ? customElement :
            !item.ui_isHistoryItem
            && hasPermissionAndCapacityToAddContent(false)
            && prosConnect.hasPermissionTo("editObj", item, undefined, false)
            && prosConnect.hasCapacityAndPermissionToAddContent(false)
                ? <ItemMenuDropdown item={item} />
                : null
        }
    </footer>
}

export function TextContent({text, ...props}){
    const [expand, setExpand] = useState(props.expand || false)
    const maxLength = props.maxLength || 400

    function renderButton(){
        return <>
            {!expand && text.length > maxLength ? <>...</> : null}{text.length > maxLength ? <span
                onClick={evt => {
                    evt.preventDefault()
                    evt.stopPropagation()
                    setExpand(!expand)
                }}
                className={"capsule"
                    + (expand ? " active" : "")
                }
            >
                {expand ? 'piilota' : 'näytä'}
                <UiIcon icon={"chevron-" + (expand ? "up" : "down")} size={"xs"} color={"main"}/>
            </span> : null}
        </>
    }

    return <p className={"text-content"
            + (expand ? " expand" : "")}>
        {!expand && text.length > maxLength
            ? text.substring(0, maxLength).trim() : text.length > maxLength
                ? <div className={"scrollpane-vertical"}>{text}</div> : text}
        {renderButton()}
    </p>
}

export function UiBoxMedia({item, isObsAuthor, isExpanded, customElement, ...props}) {
    const [expand, setExpand] = useState(isExpanded || false)
    const [imageLoaded, setImageLoaded] = useState(false)
    // const [showMarkers, setShowMarkers] = useState( false)
    const [src, setSrc] = useState(props.hasOwnProperty('no_thumb') && props.no_thumb
        ? prosConnect.getItemImagePath(item)
        : prosConnect.getItemThumpPath(item))

    useEffect(() => {
        setExpand(isExpanded)
    }, [isExpanded])

    async function updatePictureLocItemToServer(pict_item){
        pict_item[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM_PICT_LOC
        await prosConnect.getActiveProject().awaitUpdateItem(pict_item, true)
    }

    function renderToggleSizeButton(btnClass){
        //in future uiboxmedia will have video, audio etc content
        if(item.ui_isHistoryItem || !isPictureItem(item)) {
            return null
        }
        return <BasicButton
            btnClass={btnClass}
            icon={expand ? "minimize" : "expand"}
            action={()=> {
                setExpand(!expand)
                prosConnect.toggleImageSize(item)
            }}
            size={"md"}
            title={expand ? "Pienennä" : "Suurenna"}
        />
    }

    function renderRotateButton(btnClass){
        if (!hasPermissionAndCapacityToAddContent(false) || !expand) {
            return null
        }
        return <BasicButton
            btnClass={btnClass}
            icon={"rotate-cw"}
            action={()=> {
                openItemBasicModal('Käännä kuva', <RotatePicture
                    item={item}
                    editCallback={src=> {
                        setSrc(prosConnect.getItemThumpPath(item))
                    }}
                />)
            }}
            size={"md"}
            btnType="prompt"
            title="Käännä kuva"
        />
    }

    function renderPicture(onClickPicture) {
       if (prosConnect.isWaitingThumpNail(item)) {
            return <>
                <div
                    draggable={false}
                    className={"media media-image padding flex-grow"}
                >
                    <LoadingAnimation text={"Odottaa kuvan käsittelyä"}/>
                </div>
                <UiItemFooter item={item} isObsAuthor={isObsAuthor}/>
            </>
       } else if(expand) {
            return <ImageWithMarker
                key={"ImageWithMarker__" + item.obj_id}
                item={item}
                minimizePicture={()=>{
                    prosConnect.toggleImageSize(item)
                    setExpand(false)
                }}
                updateItem={updatePictureLocItemToServer}
                hasPermissions={prosConnect.hasCapacityAndPermissionToAddContent(true)}
                imageEditControls={renderRotateButton("primary")}
            />
       }else{
            // Todo Sampo: when imagePath url is undefined should show "wait a bit - image is under contruction"
            //      happens for a video when server transcoder has not yet saved thumb nail or updated video's DB obj
            //      Perhaps make such a jpg "wait ..." image and use that url instead ?
            return <>
                <div
                    draggable={false}
                    className={"media media-image"}
                >
                    <UiImage
                        imageSrc={src}
                        item={item}
                        action={evt => {
                            evt.stopPropagation()
                            if (item.ui_isHistoryItem || props?.no_edit) return
                            onClickPicture(item)
                        }}
                        onImageLoad={()=> {
                            setImageLoaded(true)
                        }}
                    />
                </div>
                {imageLoaded && ! props?.no_edit ? <div className={"media-controls btn-set padding-sm"}>
                    {renderToggleSizeButton()}
                </div> : null}
                <UiItemFooter item={item} isObsAuthor={isObsAuthor} customElement={customElement}/>
            </>
       }
    }

    return <div
            draggable={false}
            className={"box-media element-set-v" + (expand ? " box-media-full" : "")}
        >
            {renderPicture(()=>{
               setExpand(!expand)
            })}
    </div>
}

export function renderVideo(item) {
    return <div key={item.obj_id + '__rv'}
            draggable={false}
            className={"box-media"}
        >
        <VideoPlayer item={item} />
        <UiItemFooter item={item} />
    </div>
}

export function renderAudio(item, isObsAuthor) {
    return <div key={item.obj_id + '__a'}
            onClick={(evt) => {
                //Removed evt.preventDefault as it broke outbound links in comments
                evt.stopPropagation()//not sure if these do anything
                evt.nativeEvent.stopImmediatePropagation()//not sure if these do anything
            }}
            draggable={false}
            className={"box-media box-text"}
        >
        <AudioPlayer item={item}/>
        <UiItemFooter item={item} isObsAuthor={isObsAuthor}/>
    </div>
}

export function renderAudioText(item, isObsAuthor) {
    return <div key={item.obj_id + '__at'}
            onClick={(evt) => {
                //Removed evt.preventDefault as it broke outbound links in comments
                evt.stopPropagation()//not sure if these do anything
                evt.nativeEvent.stopImmediatePropagation()//not sure if these do anything
            }}
            className={"box-media box-text"}
        >
        {renderCommentText(item, isObsAuthor)}
    </div>
}

export function renderCommentText(item, isObsAuthor) {
    let itemValue = prosConnect.getItemText(item)
    let link = getLinkAddr(itemValue)
    if (link) {
        let restText = link.linkText ? link.linkText.split('\n') : []
        itemValue = <>
            <a href={link.link} target={"_blank"}
               rel={"noopener noreferrer"}>{restText.length >= 1 ? restText.shift() : link.link}</a>
            <br/>
            {restText.join('\n')}
        </>
    }
    const hasAudio = prosConnect.getValidAttr(item, ATTR_FILE_NAME, STR_NO_VALUE) !== STR_NO_VALUE
    return <>
        <p className={"flex-grow"}>{itemValue}</p>
        {hasAudio && item[prosConnect.ATTR_CREATED_BY] === prosConnect.getUserEmail(true) ?
            <AudioPlayer item={item}/> : null}
        <UiItemFooter item={item} isObsAuthor={isObsAuthor} />
    </>
}

export function renderComment(item, isObsAuthor) {
    return <div
        key={item.obj_id + '__rc'}
        onClick={(evt) => {
            //Removed evt.preventDefault as it broke outbound links in comments
            evt.stopPropagation()//not sure if these do anything
            evt.nativeEvent.stopImmediatePropagation()//not sure if these do anything
        }}
        className={"box-media box-text"
            + (contentByWhomClasses(item, isObsAuthor))
        }
    >
        {renderCommentText(item, isObsAuthor)}
    </div>
}

export function renderTitle(item) {
    return <div
            key={item.obj_id + '__rt'}
            onClick={(evt) => {
                evt.preventDefault()
                evt.stopPropagation()
            }}
            className={"box-text element-set valign-center"}
        >
        <h2 className={"flex-grow margin-0"}>
            {prosConnect.getItemText(item)}
        </h2>
        {renderTitleMenu(item)}
    </div>
}

function renderTitleMenu(item) {
    if (item.hasOwnProperty(prosConnect.UI_ATTR_NO_EDIT)
        || !prosConnect.hasPermissionTo("editObj", item, undefined, false)
        || !prosConnect.hasCapacityAndPermissionToAddContent(false)) {
        return null
    }
    return <div className={"valign-top"}>
        <ItemMenuDropdown item={item} />
    </div>
}

export function renderItemByType(item, obsAuthor, isReordering, reportParent) {
    const type = prosConnect.renderType(item)
    let elem = null
    const isObsAuthor = item ? item[prosConnect.ATTR_CREATED_BY] === obsAuthor : false

    switch (type) {

        case 'pict':
            elem = <UiBoxMedia key={"bm__" + item[ATTR_OBJ_ID]} item={prosConnect.getOriginal(item)} isObsAuthor={isObsAuthor} />
            break

        case 'audio':
            elem = renderAudio(item, isObsAuthor)
            break

        case 'audio_txt':
            elem = renderAudioText(item, isObsAuthor)
            break

        case 'title':
            elem = renderTitle(item)
            break

        case 'video':
            elem = renderVideo(item, isObsAuthor)
            break

        default:
            elem = renderComment(item, isObsAuthor)
            break
    }
    if(isReordering) return <div
             key={item[ATTR_OBJ_ID]}
             draggable={true} className={"drag-element"}
             onDragStart={e => getCopyMoveManager().onDragStart(e, item)}
             onDragOver={e => getCopyMoveManager().onDragOver(e, item)}
             onDragLeave={e => getCopyMoveManager().onDragLeave(e)}
             onDrop={e => getCopyMoveManager().onDrop(e, item)}
        >
            {elem}
        </div>
    if(item.ui_removed){
        return renderWithRestoreControls(elem, item, reportParent)
    }
    return elem
}

export function AddEditObjectType(props){
    const acceptedObjTypes = ['itm', 'itm_title', 'itm_obs']
    let newItemType = ''//not sure why string
    if(!props.editMode){
        if(props.obj[ATTR_OBJ_TYPE] !== OBJ_TYPE_ITM_OBS){
            newItemType = acceptedObjTypes.includes(props.obj[ATTR_OBJ_TYPE]) ? props.obj[ATTR_OBJ_TYPE] : OBJ_TYPE_ITM
        }else{
            newItemType = OBJ_TYPE_ITM_OBS
        }
    }
    const [newObjectType, setNewObjectType] = useState(props.editMode ? props.obj[ATTR_OBJ_TYPE] : newItemType)
    const [text, setText] = useState(props.editMode ? props.obj[ATTR_TEXT] : '')
    //check if is inside obs
    const afterItemBelongToObs = props.afterObj && prosConnect.getActiveProject().isObsChildItem(props.afterObj)
    const saveObjectTypeChange = async ()=> {
        prosAppNotifWait("Muutetaan ..")
        await prosConnect.getActiveProject().saveObjectTypeChange(props.obj, newObjectType)
        BasicModalDismiss()
    }

    const saveNewItemAfter = async ()=> {
        let name = validateTextInput(text)
        if (!name) return
        //afterObj is same as props.obj, set only if not in edit mode
        let afterObjId = props.afterObj[ATTR_OBJ_ID]
        let reportId = props.reportId
        switch (newObjectType){
            case 'itm':
                await prosConnect.getActiveProject().awaitAddTextItem(name, reportId, afterObjId)
                break

            case 'itm_title':
                await prosConnect.getActiveProject().awaitAddTitle(name, reportId, afterObjId)
                break

            default:
                checkToWarnCloseToCapacityLimit()
                await prosConnect.getActiveProject().awaitAddObs(name, reportId, afterObjId)
                break
        }
        BasicModalDismiss()
    }

    function renderChangeToObs (){
        if (isSettingsView()) {
            return null
        }
        return <RadioButton
            checked={newObjectType === 'itm_obs'}
            text={"Kirjaus"}
            onChange={() => setNewObjectType('itm_obs')}
        />
    }

    function submitData(){
        if(props.editMode) saveObjectTypeChange(props.obj)
        else saveNewItemAfter()
    }
    function renderAddItemInput(){
        if(props.editMode) return null
        const label = newObjectType ? getTextForObjectType('Lisää', null, newObjectType)
            :  getTextForObjectType('Lisää', props.obj)
        return <TextInput
            label={label}
            value={text}
            onChange={(val)=> {
                setText(val)
            }}
            multiline={3}
            onSubmit={()=> isDataValid() ? submitData() : ()=>{}}
            hideSubmitButton
        />
    }

    function isDataValid(){
        if(props.editMode) return true
        return text.length > 0 && (newObjectType.length > 0 || afterItemBelongToObs)
    }

    function renderSelectOptions(){
        if(afterItemBelongToObs) return null
        return <div className="selection-group selection-group-radio">
            {renderChangeToObs()}
            <RadioButton
                checked={newObjectType === 'itm'}
                text="Kommentti"
                onChange={() => {
                    setNewObjectType('itm')
                }}
            />
            <RadioButton
                checked={newObjectType === 'itm_title'}
                text="Otsikko"
                onChange={() => setNewObjectType('itm_title')}
            />
        </div>
    }

    return <>
        <section>
            {renderSelectOptions()}
            {renderAddItemInput()}
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={BasicModalDismiss}
                />
                <ConfirmButton
                    disabled={!isDataValid()}
                    action={()=> {
                        submitData()
                    }}
                />
            </div>
        </footer>
    </>
}

export function ItemMenuDropdown({item, ...props}){
    if(item.ui_isHistoryItem) return null
    const isSourceItem = getCopyMoveManager().isCopyMoveSource(item)
    const isValidTarget = getCopyMoveManager().isValidCopyMoveTarget(item)
    let menuItems = getItemMenuItems(item)
    const hasPermissions = prosConnect.hasCapacityAndPermissionToAddContent(false) && prosConnect.hasPermissionTo("editObj", item, undefined, false)
    if(menuItems){
        if(menuItems.length < 1 && hasPermissions) return null
        return <DropdownMenu
            values={menuItems}
            showTexts
            text={false}
            icon={"ellipsis-v"}
            hideArrow
            btnClass={"3rd"}
            className={"ui-dropdown-align-right"
                + (isValidTarget ? " super-hilite" : "")
                + (isVideoItem(item) || isPictureItem(item) ? " ui-dropdown-up" : "")
            }
            active={isSourceItem}
            openDropdownCallback={()=> {
                if(props.toggleCallback) props.toggleCallback(true)
                let itemType = null
                if(item[ATTR_OBJ_TYPE] === 'itm_obs') itemType = 'obsMenu'
                else if(item[ATTR_OBJ_TYPE] === 'itm') itemType = 'commentMenu'
                else if(item[ATTR_OBJ_TYPE] === 'itm_pict'
                    || item[ATTR_OBJ_TYPE] === 'itm_pict_loc') itemType = 'pictureMenu'
                if(itemType) setHelpContext(itemType)
            }}
            btnType={!hasPermissions ? "locked" : null}
            closeDropdownCallback={()=> {
                if(props.toggleCallback) props.toggleCallback(false)
                setHelpContext('closePopup')
            }}
        />
    }
}

function getObsOrItemReportId(item){
    return getObjListIdFromItemId(item[ATTR_OBJ_ID])
}

export function isListView(){
    return gloGetReportView() === VIEW_MODE_LIST
}

function renderChangeItemTypeMenu(item) {
    if (!featureEnabled(FEAT_CHANGE_ITEM_TYPE) || !isListView()) {
        return {}
    }
    return {
        text: 'Vaihda tyyppiä',
        icon: 'change-type',
        action: ()=> changeObjectTypeModal(item, true),
        btnType: 'prompt'
    }
}

function renderAddAfterObsMenu(obs, itemArray = null) {
    if (!prosConnect.hasPermissionTo("addContent", undefined, undefined) || !isListView()) {
        return itemArray
    }
    if (getActiveProject().hasCapacityToAddItems()) {
        if(itemArray){
            itemArray.push({
                text: 'Lisää kirjauksen jälkeen',
                icon: 'plus',
                action: ()=> changeObjectTypeModal(obs),
                btnType: 'prompt'
            })
            return itemArray
        }
    }
    return itemArray
}

function alertArchivedProjectCanNotBeEdited() {
    let project = prosConnect.getActiveProject()
    if (project && !project.isProjectActive()) {
        prosAppNotif("Arkistoitua projektia ei voi muokata")
        return true
    }
    return false
}
function openItemBasicModal(title, content, params, item = null){
    if (alertArchivedProjectCanNotBeEdited()) {
        return
    }
    BasicModal(title, content, {
        hideDismissButton: true
    })
    if(item) selectPopupHelpContext(item)
}

function getItemMenuItems(item){
    if (!prosConnect.hasPermissionTo("addContent", undefined, undefined)) {
        return []
    }
    let origObj = prosConnect.getOriginal(item)
    let dropdownItems = []
    if(getCopyMoveManager().isCopyOrMoveMode()){
        if(origObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM
            || prosConnect.isPictureItem(item)) return getMoveObjectMenu(item, [])
        if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
            || item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
            dropdownItems = getCopyObjectMenu(item, [])
            dropdownItems = getMoveObjectMenu(item, dropdownItems)
            return dropdownItems
        }
        else return []
    }

    //if is comment or sound to text
    if (origObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM || origObj[ATTR_OBJ_TYPE] === OBJ_TYPE_TXT_SOUND) {
        dropdownItems.push({
            text: 'Muokkaa',
            icon: 'edit',
            action: () => {
                openItemBasicModal('Muokkaa tekstiä', renderTextEdit(item))
            },
            btnType: 'prompt'
        })
        if(origObj[ATTR_OBJ_TYPE] !== OBJ_TYPE_TXT_SOUND) dropdownItems.push(renderChangeItemTypeMenu(origObj))
        dropdownItems.push(renderAddAftertMenuItem(item, 'Lisää kommentin jälkeen'))
        dropdownItems = getMoveObjectMenu(item, dropdownItems)
        dropdownItems.push({
            text: 'Poista',
            icon: 'bin',
            action: ()=> {
                openItemBasicModal('Poista kommentti', renderDeletetItemModal(item))
            },
            btnType: 'prompt'
        })
    } else if(prosConnect.isPictureItem(item)) {
        if (prosConnect.hasPermissionTo("manageObj", item, undefined, false)) {
            if (item.ui_isHistoryItem) {
                dropdownItems.push(renderUndoDeletedControl(item, true))
            } else {
                dropdownItems.push(renderAddAftertMenuItem(item, 'Lisää kuvan jälkeen'))
                dropdownItems = getMoveObjectMenu(item, dropdownItems)
                dropdownItems.push(isPdfFile(origObj))
                dropdownItems.push({
                    icon: 'download',
                    text: 'Lataa kuva',
                    action: async ()=>{
                        const image = await fetch(prosConnect.getItemImagePath(item))
                        const imageBlog = await image.blob()
                        const imageURL = URL.createObjectURL(imageBlog)
                        const link = document.createElement('a')
                        link.href = imageURL
                        link.download = 'prodect_' + item[ATTR_FILE_NAME]
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                    }
                })
                dropdownItems.push({
                    text: 'Poista',
                    icon: 'bin',
                    action: () => {
                        openItemBasicModal('Poista kuva', renderDeletetItemModal(item))
                    },
                    btnType: 'prompt'
                })
            }
        }
    }else if(isVideoItem(item)){
        dropdownItems.push({
            icon: 'delete',
            text: 'Poista',
            action: () => {
                openItemBasicModal('Poista video', renderDeletetItemModal(item))
            },
            btnType: 'prompt'
        })
    }else if(origObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE){
        dropdownItems.push({
            text: 'Muokkaa',
            icon: 'edit',
            action: ()=> {
                openItemBasicModal('Muokkaa otsikkoa', renderTextEdit(item))
            },
            btnType: 'prompt'
        })
        dropdownItems.push(renderChangeItemTypeMenu(origObj))
        dropdownItems.push(renderAddAftertMenuItem(item, 'Lisää otsikon jälkeen'))
        dropdownItems.push({
            text: 'Poista',
            icon: 'bin',
            action: ()=> {
                openItemBasicModal('Poista otsikko', renderDeletetItemModal(item))
            },
            btnType: 'prompt'
        })
    }else if(item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS){
        if(canAddEditObs()){
            dropdownItems.push({
                element: <EditObsButton
                    obs={item}
                    report={getObsOrItemReportId(item)}
                    label={"Muokkaa..."}
                />
            })
        }
        dropdownItems.push(renderChangeItemTypeMenu(origObj))
        dropdownItems = renderAddAfterObsMenu(item, dropdownItems)
        dropdownItems = getCopyObjectMenu(item, dropdownItems)
        dropdownItems = getMoveObjectMenu(item, dropdownItems)
        dropdownItems.push({
            icon: 'copy',
            text: 'Luo www-linkki',
            action: async ()=> {
                //Todo Sampo: This will work only if copying to clipboard works, no fallback atm.
                makeAndSaveProjectLink(gloGetReportView(), prosConnect.getValidAttr(item, ATTR_OBS_ID, item[ATTR_OBJ_ID]))
            }
        })
        if(canAddEditObs()){
            dropdownItems.push({
                icon: 'bin',
                text: 'Poista',
                action: ()=> {
                    openItemBasicModal('Poista kirjaus', renderDeletetItemModal(item))
                },
                btnType: 'prompt'
            })
        }
    }
    if(prosConnect.userHasDebugMenu() && !getCopyMoveManager().isCopyOrMoveMode()) dropdownItems.push({
        element: <BasicButton
            label={"Dump obj"}
            icon={"search"}
            action={() => {
                prosConnect.dumpProsObj(item)
                BasicModalDismiss()
            }}
        />
    })
    return dropdownItems
}

function getMoveObjectMenu(obj, itemArray = []) {
    prosConnect.renderType(obj)
    function moveMenuToTarget() {
        function getObjText(obj, defaultText) {
            if(isValidAttr(prosConnect.getOriginal(obj)[ATTR_TEXT])){
                return prosConnect.getOriginal(obj)[ATTR_TEXT]
            }
            return defaultText
        }

        function shortened(txt) {
            const MAX_TXT_LEN_IN_MENU = 12
            if (!txt || txt === STR_NO_VALUE || txt === "") {
                return " "
            }
            if (txt.length < MAX_TXT_LEN_IN_MENU+2) {
                return ' "' + txt + '" '
            }
            return ' "' + txt.substr(0, MAX_TXT_LEN_IN_MENU) + '.." '
        }

        let sourceObj = getCopyMoveManager().getSource();
        let moveobjText = getObjText(sourceObj, "Kuva");
        let afterobjText = getObjText(obj, "Kuva");
        if (getCopyMoveManager().movingItemIntoObs(obj)) {
            return "Siirrä" + shortened(moveobjText) + shortened(afterobjText) + " sisälle";
        }
        return "Siirrä" + shortened(moveobjText) + shortened(afterobjText) + " jälkeen"
    }
    if (!prosConnect.hasPermissionToReorder() || !isListView()) {
        return itemArray
    }
    if (getCopyMoveManager().isCopyMode()) {
        return itemArray
    }
    if (getCopyMoveManager().isMoveMode()) {
        if (!getCopyMoveManager().isValidCopyMoveTarget(obj)) {
            itemArray.push({
                text: 'Peru siirto',
                icon: 'cancel',
                action: ()=> cancelMoveOrCopy()
            })
        }else{
            itemArray.push({
                text: moveMenuToTarget(),
                icon: 'document-move',
                action: ()=> doMoveObject(obj)
            },{
                text: 'Peru siirto',
                icon: 'cancel',
                action: ()=> cancelMoveOrCopy()
            })
        }
    } else {
        itemArray.push({
            text: getTextForObjectType("Siirrä", obj),
            icon: "document-move",
            action: ()=> setMoveObjectMode(obj)
        })
    }
    return itemArray
}

function getCopyObjectMenu(obj, itemArray = null) {
    if (!prosConnect.hasPermissionToReorder() || !isListView()) {
        return []
    }
    if (getCopyMoveManager().isCopyMode()) {
        const itemText = isTitle(obj) ? 'otsikon' : 'kirjauksen'
        return [{
            text: 'Liitä kopio tämän ' + itemText + ' jälkeen',
            icon: "copy",
            action: ()=> doCopyObservation(obj)
        },
            {
                text: "Peru kopiointi",
                icon: "cancel",
                action: ()=> cancelMoveOrCopy()
            }]
    } else {
        if (!getCopyMoveManager().isMoveMode()) {
            itemArray.push({
                text: getTextForObjectType("Kopioi", obj),
                icon: "copy",
                action: () => setCopyObjectMode(obj)
            })
        }
        return itemArray
    }
}

function cancelMoveOrCopy() {
    prosAppNotifDismiss()
    getCopyMoveManager().cancelOperations()
    BasicModalDismiss()
    prosConnect.getGlobalRef(true)
}

function setCopyObjectMode(obj) {
    getCopyMoveManager().markCopySource(obj);
    BasicModalDismiss()
    prosAppNotif('Valitse minkä jälkeen kopioidaan', {
        type: 'notice',
        action: ()=> cancelMoveOrCopy(),
        buttonText: 'Peru kopiointi',
        icon: 'cancel'
    })
}

function setMoveObjectMode(obj) {
    getCopyMoveManager().markMoveSource(obj)
    BasicModalDismiss()
    prosAppNotif('Valitse minkä jälkeen siirretään.',
     {
        type: 'notice',
        action: () => cancelMoveOrCopy(),
        buttonText: 'Peru siirto',
        icon: 'cancel'
     })
}

async function doCopyObservation(afterObs) {
    getCopyMoveManager().awaitCopy(afterObs)
    checkToWarnCloseToCapacityLimit()
    BasicModalDismiss()
    cancelMoveOrCopy()
}

async function doMoveObject (afterObj) {
    await getCopyMoveManager().awaitMove(afterObj)
    BasicModalDismiss()
    cancelMoveOrCopy()
}

function isPdfFile(obs) {
    if (obs.hasOwnProperty(ATTR_PDF_NAME)) {
        return {
            text: 'Aukaise katseltavaksi',
            icon: 'open-new',
            action: ()=> {
                openPdf(obs)
            }
        }
    }else{
        return {}
    }
}

function openPdf(obs) {
    let url = prosConnect.getItemPdfPath(obs);
    openUrl(url);
}

function itemTitleGenetiivi(item) {
    const OBJ_ITEM__GENETIVES = {
        [OBJ_TYPE_ITM_TITLE] : "otsikon",
        [OBJ_TYPE_ITM_OBS]: "kirjauksen",
        [OBJ_TYPE_ITM]: "tekstin",
        [OBJ_TYPE_ITM_VIDEO]: "videon",
        [OBJ_TYPE_ITM_PICT] : "kuvan",
        [OBJ_TYPE_ITM_PICT_LOC]: "kuvan"
    }
    return OBJ_ITEM__GENETIVES[item.obj_type] || "tiedon"
}

function renderDeletetItemModal(item) {
    // Default restorable item types are currently also hard configured
    // in the web history endpoint in the backend server
    let cancellable = [
        OBJ_TYPE_LST, OBJ_TYPE_ITM_OBS, OBJ_TYPE_ITM,
        OBJ_TYPE_ITM_PICT, OBJ_TYPE_ITM_PICT_LOC,
        OBJ_TYPE_ITM_TITLE, OBJ_TYPE_SOUND, OBJ_TYPE_TXT_SOUND
    ].includes(item.obj_type)
    const cancellationHint = cancellable
        ? <p>Voit perua poiston asetuksista kohdasta 'Tietojen palautus'.</p>
        : <p><strong className={"color-2nd"}>Poistettuja tietoja ei voi palauttaa toiminnon jälkeen.</strong></p>
    return <>
        <section>
            <p>Oletko varma että haluat poistaa {itemTitleGenetiivi(item)}?</p>
            {cancellationHint}
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={BasicModalDismiss}
                />
                <ConfirmButton
                    icon={cancellable ? "bin" : "delete"}
                    btnType={"fatal"}
                    action={()=> removeItem(item)}
                />
            </div>
        </footer>
    </>
}

async function removeItem(item) {
    //remove items, not used for obs
    prosConnect.prosLog('removeItem()', item[ATTR_OBJ_ID])
    await prosConnect.getActiveProject().awaitRemoveItem(item)
    BasicModalDismiss()
}
function saveWebLink(item, link) {
    saveTextEdit(item, link.link + '\n' + link.linkText)
}

function renderTextEdit(item) {
    let originalObj = prosConnect.getOriginal(item)
    let itemValue = prosConnect.getItemText(item)
    let link = getLinkAddr(itemValue)
    if (link) return <ProsLinkEditPopup
        link={link}
        item={item}
        saveLink={saveWebLink}
    />
    const hasAudio = prosConnect.getValidAttr(item, ATTR_FILE_NAME, STR_NO_VALUE) !== STR_NO_VALUE
    return <>
        <section>
            <TextInput
                label={"Muokkaa tekstiä"}
                value={itemValue}
                id={"prodect-edit-txt"}
                multiline={3}
            />
            {hasAudio && item[prosConnect.ATTR_CREATED_BY] === prosConnect.getUserEmail(true) ? <AudioPlayer item={item}/> : null}
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={BasicModalDismiss}
                />
                <ConfirmButton
                    action={()=> {
                        let txt = document.getElementById("prodect-edit-txt").value
                        saveTextEdit(originalObj, txt)
                    }}
                />
            </div>
        </footer>
    </>
}

function changeObjectTypeModal(item, editMode = false) {
    let content = <AddEditObjectType
        obj={item}
        editMode={editMode}
        afterObj={!editMode ? item : null}
        reportId={getObsOrItemReportId(item)}
    />
    return openItemBasicModal(item[ATTR_TEXT] !== STR_NO_VALUE ? item[ATTR_TEXT] : (editMode ? 'Muokkaa' : 'Lisää'), content)
}

async function saveTextEdit(item, text) {
    let changedAttrs = {
        [ATTR_OBJ_ID]: item[ATTR_OBJ_ID],
        [ATTR_OBJ_TYPE]: item[ATTR_OBJ_TYPE],
        [ATTR_TEXT]: text
    }
    await prosConnect.getActiveProject().awaitUpdateMultipleItemsAttributes([changedAttrs])
    BasicModalDismiss()
}

//Todo Jere: This functionality not set yet?
function selectPopupHelpContext(item) {
    if (item) {
        let orig = prosConnect.getOriginal(item)
        if (orig[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
            setHelpContext('obsMenu')
        } else if (prosConnect.isPictureItem(orig) || orig[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_VIDEO) {
            setHelpContext('pictureMenu')
        } else if (orig[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM || orig[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
            setHelpContext('commentMenu')
        } else if (orig[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
            setHelpContext('obsMenu')
        }
    }
}

function renderAddAftertMenuItem(obj, label) {
    if(!hasPermissionAndCapacityToAddContent(obj[ATTR_OBJ_TYPE])) return {}
    return {
        text: label,
        icon: 'plus',
        action: () => {
            changeObjectTypeModal(obj, false)
        },
        btnType: 'prompt'
    }
}